// source: type/external_admin_ip_option.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_descriptor_pb = require('google-protobuf/google/protobuf/descriptor_pb.js');
goog.object.extend(proto, google_protobuf_descriptor_pb);
goog.exportSymbol('proto.type.externalAdminIpUnrestricted', null, global);

/**
 * A tuple of {field number, class constructor} for the extension
 * field named `externalAdminIpUnrestricted`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */
proto.type.externalAdminIpUnrestricted = new jspb.ExtensionFieldInfo(
    50002,
    {externalAdminIpUnrestricted: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.MethodOptions.extensionsBinary[50002] = new jspb.ExtensionFieldBinaryInfo(
    proto.type.externalAdminIpUnrestricted,
    jspb.BinaryReader.prototype.readBool,
    jspb.BinaryWriter.prototype.writeBool,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MethodOptions.extensions[50002] = proto.type.externalAdminIpUnrestricted;

goog.object.extend(exports, proto.type);
